import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import yup from 'yup'
import Form from 'react-formal'
import types from 'react-formal-inputs'
import 'react-widgets/lib/less/react-widgets.less'
import Spinner from './../common/Spinner'
import { Checkbox, Col } from 'react-bootstrap'

class AppEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            appLoaded: false,
            formValues: {
                name: null
            },
            formKey: moment.utc().toISOString(),
            marketplace: false,
            allPlatforms: ['Mercado Pago', 'Moip'],
            loading: false
        }
        Form.addInputTypes(types)
        momentLocalizer(moment)
    }

    componentDidMount() {
        var self = this
        self.props.actions.appGetOne(self.props.params.appId)
    }

    componentDidUpdate() {
        this.loadApp()
    }

    loadApp() {
        var self = this
        if (self.props.app && !self.state.appLoaded) {
            let mp = (self.props.app.payments && self.props.app.payments.mercadopago) ? self.props.app.payments.mercadopago : undefined
            let moip = (self.props.app.payments && self.props.app.payments.moip) ? self.props.app.payments.moip : undefined
            let mpActive = false
            let moipActive = false
            if (self.props.app.payments && self.props.app.payments.mercadopago && self.props.app.payments.mercadopago !== {}) {
                mpActive = true
            }
            if (self.props.app.payments && self.props.app.payments.moip && self.props.app.payments.moip !== {}) {
                moipActive = true
            }
            self.setState({
                appLoaded: true,
                marketplace: self.props.app.marketplace || false,
                formValues: {
                    mpActive: mpActive,
                    moipActive: moipActive,
                    name: self.props.app.name || undefined,
                    mercadopago: {
                        publicKey: (mp && mp.publicKey) ? mp.publicKey : undefined,
                        accessToken: (mp && mp.accessToken) ? mp.accessToken : undefined,
                        appId: (mp && mp.app && mp.app.appId) ? mp.app.appId : undefined,
                        appSecret: (mp && mp.app && mp.app.appSecret) ? mp.app.appSecret : undefined,
                        fee: (mp && mp.app && mp.app.fee) ? mp.app.fee : undefined
                    },
                    moip: {
                        publicKey: (moip && moip.publicKey) ? moip.publicKey : undefined,
                        accessToken: (moip && moip.accessToken) ? moip.accessToken : undefined,
                        accessKey: (moip && moip.moip && moip.moip) ? moip.moip : undefined,
                        site: (moip && moip.site && moip.site) ? moip.site : undefined
                    }
                }
            }, function() {
                self.setState({
                    formKey: moment.utc().toISOString()
                })
            })
        }
    }

    goBack() {
        browserHistory.go(-1)
    }

    getModelSchema() {
        var self = this
        let mp = (self.props.app && self.props.app.payments && self.props.app.payments.mercadopago) ? self.props.app.payments.mercadopago : undefined
        let moip = (self.props.app && self.props.app.payments && self.props.app.payments.moip) ? self.props.app.payments.moip : undefined
        var yupSchema = {
            mpActive: yup.boolean().nullable().default(self.state.formValues.mpActive),
            moipActive: yup.boolean().nullable().default(self.state.formValues.moipActive),
            name: yup.string().required('Ingrese nombre').default(self.props.app && self.props.app.name),
            platform: yup.array().of(yup.string()).default([])
        }

        if (self.state.formValues.mpActive) {
            yupSchema.mercadopago = yup.object({
                publicKey: yup.string().required('Ingrese public Key').default((mp && mp.publicKey) ? mp.publicKey : undefined),
                accessToken: yup.string().required('Ingrese accessToken').default((mp && mp.accessToken) ? mp.accessToken : undefined),
                appId: yup.string().required('Ingrese app Id').default((mp && mp.app && mp.app.id) ? mp.app.id : undefined),
                appSecret: yup.string().required('Ingrese app Secret').default((mp && mp.app && mp.app.secret) ? mp.app.secret : undefined),
                fee: yup.string().nullable().default((mp && mp.app && mp.app.fee) ? mp.app.fee : undefined)
            })
        } else {
            yupSchema.mercadopago = yup.object({
                publicKey: yup.string(),
                accessToken: yup.string(),
                appId: yup.string(),
                appSecret: yup.string(),
                fee: yup.string()
            })
        }

        if (self.state.formValues.moipActive) {
            yupSchema.moip = yup.object({
                publicKey: yup.string().required('Ingrese public Key').default((moip && moip.publicKey) ? moip.publicKey : undefined),
                accessToken: yup.string().required('Ingrese accessToken').default((moip && moip.accessToken) ? moip.accessToken : undefined),
                accessKey: yup.string().required('Ingrese la accessKey').default((moip && moip.accessKey) ? moip.accessKey : undefined),
                site: yup.string().required('Ingrese el sitio web').default((moip && moip.site) ? moip.site : undefined),
                fee: yup.string().nullable().default((mp && mp.app && mp.app.fee) ? mp.app.fee : undefined)
            })
        } else {
            yupSchema.moip = yup.object({
                publicKey: yup.string(),
                accessToken: yup.string(),
                accessKey: yup.string(),
                site: yup.string(),
                fee: yup.string()
            })
        }

        if (self.state.marketplace) {
            yupSchema.mercadopago.fee = yup.string().required('Ingrese fee').default((mp && mp.app && mp.app.fee) ? mp.app.fee : undefined)
            yupSchema.moip.fee = yup.string().required('Ingrese fee').default((moip && moip.app && moip.app.fee) ? moip.app.fee : undefined)
        }

        return yup.object(yupSchema)
    }

    appEdit(formValues) {
        var self = this
        var name = formValues.name
        let app = {
            payments: {}
        }
        if (self.state.formValues.mpActive) {
            app.payments.mercadopago = {
            }
            if (!app.payments.mercadopago.app) {
                app.payments.mercadopago.app = {}
            }
            if (formValues.mercadopago.appId && formValues.mercadopago.appId !== '') {
                app.payments.mercadopago.app.id = formValues.mercadopago.appId
            }
            if (formValues.mercadopago.appSecret && formValues.mercadopago.appSecret !== '') {
                app.payments.mercadopago.app.secret = formValues.mercadopago.appSecret
            }
            if (formValues.mercadopago.fee && formValues.mercadopago.fee !== '' && self.state.marketplace) {
                app.payments.mercadopago.fee = formValues.mercadopago.fee
            }
            if (formValues.mercadopago.publicKey && formValues.mercadopago.publicKey !== '') {
                app.payments.mercadopago.publicKey = formValues.mercadopago.publicKey
            }
            if (formValues.mercadopago.accessToken && formValues.mercadopago.accessToken !== '') {
                app.payments.mercadopago.accessToken = formValues.mercadopago.accessToken
            }
        }

        if (self.state.formValues.moipActive) {
            app.payments.moip = {}
            if (formValues.moip.publicKey && formValues.moip.publicKey !== '') {
                app.payments.moip.publicKey = formValues.moip.publicKey
            }
            if (formValues.moip.accessToken && formValues.moip.accessToken !== '') {
                app.payments.moip.accessToken = formValues.moip.accessToken
            }
            if (formValues.moip.accessKey && formValues.moip.accessKey !== '') {
                app.payments.moip.accessKey = formValues.moip.accessKey
            }
            if (formValues.moip.site && formValues.moip.site !== '') {
                app.payments.moip.site = formValues.moip.site
            }
        }
        var object = {
            name: name,
            marketplace: self.state.marketplace,
            payments: app.payments
        }
        self.setState({ loading: true })
        self.props.actions.appEdit(self.props.params.appId, object).then(function() {
            self.setState({ loading: false })
            self.goBack()
        })
    }

    render() {
        var self = this
        var content

        if (!self.props.app) {
            content = <Spinner />
        } else {
            var contentPlatform = <div>
                  <div className='row'>
                      <div className='form-group col-md-12'>
                      <h3 className='page-header'>Mercadopago</h3>
                      </div>
                  </div>
                  <div className='form-group'>
                      <Form.Field name='mpActive' value = {self.state.formValues.mpActive} type='select' className='form-control'>
                          <option value={ false }>Desactivado</option>
                          <option value={ true }>Activado</option>
                      </Form.Field>
                      <Form.Message htmlFor={['mpActive']}/>
                  </div>
                  <div className='form-group' style={{ display: self.state.formValues.mpActive ? 'block' : 'none' }}>
                  <div className='row'>
                      <div className='form-group col-md-6'>
                          <label>Public Key</label>
                              <Form.Field name='mercadopago.publicKey' placeholder='Public Key' className='form-control'/>
                          <Form.Message htmlFor={'mercadopago.publicKey'}/>
                      </div>
                      <div className='form-group col-md-6'>
                          <label>Access Token</label>
                              <Form.Field name='mercadopago.accessToken' placeholder='Access Token' className='form-control'/>
                          <Form.Message htmlFor={'mercadopago.accessToken'}/>
                      </div>
                  </div>
                  <div className='row'>
                      <div className='form-group col-md-6'>
                          <label>App Id</label>
                              <Form.Field name='mercadopago.appId' placeholder='App Id' className='form-control'/>
                          <Form.Message htmlFor={'mercadopago.appId'}/>
                      </div>
                      <div className='form-group col-md-6'>
                          <label>App Secret</label>
                              <Form.Field name='mercadopago.appSecret' placeholder='App Secret' className='form-control'/>
                          <Form.Message htmlFor={'mercadopago.appSecret'}/>
                      </div>
                  </div>
                  </div>
                  <div className='row'>
                      <div className='form-group col-md-12'>
                          <h3 className='page-header'>Moip</h3>
                      </div>
                  </div>
                  <div className='form-group'>
                      <Form.Field name='moipActive' value = {self.state.formValues.moipActive} type='select' className='form-control'>
                          <option value={ false }>Desactivado</option>
                          <option value={ true }>Activado</option>
                      </Form.Field>
                      <Form.Message htmlFor={['moipActive']}/>
                  </div>
                  <div className='form-group' style={{ display: self.state.formValues.moipActive ? 'block' : 'none' }}>
                  <div className='row'>
                      <div className='form-group col-md-6'>
                          <label>Access Token</label>
                              <Form.Field name='moip.accessToken' placeholder='Access Token' className='form-control'/>
                          <Form.Message htmlFor={'moip.accessToken'}/>
                      </div>
                      <div className='form-group col-md-6'>
                          <label>Access Key</label>
                              <Form.Field name='moip.accessKey' placeholder='Access Key' className='form-control'/>
                          <Form.Message htmlFor={'moip.accessKey'}/>
                      </div>
                  </div>
                  <div className='row'>
                      <div className='form-group col-md-6'>
                          <label>Public Key</label>
                              <Form.Field name='moip.publicKey' placeholder='Public Key' className='form-control'/>
                          <Form.Message htmlFor={'moip.publicKey'}/>
                      </div>
                      <div className='form-group col-md-6'>
                          <label>Sitio web</label>
                              <Form.Field name='moip.site' placeholder='chat-tonic.com' className='form-control'/>
                          <Form.Message htmlFor={'moip.site'}/>
                      </div>
                  </div>
                </div>
                </div>
        }
        content = (
            <Form key={ self.state.formKey } schema={ self.getModelSchema() } defaultValue={ self.getModelSchema().default() } onChange={ (formValues, fieldUpdated) => {
                var newState = { formValues: formValues }
                self.setState(newState)
            } } onSubmit={ self.appEdit.bind(self) }>
                <div className='row'>
                    <div className='form-group col-md-6'>
                        <label>Nombre</label>
                        <Form.Field id="name" name='name' placeholder='Name' className='form-control'/>
                        <Form.Message htmlFor={'name'}/>
                    </div>
                    <div className='form-group col-md-2' key='marketplace'>
                        <Col>
                          <Checkbox onChange={() => self.setState({ marketplace: !self.state.marketplace })} defaultChecked={self.state.marketplace}>
                              Marketplace
                          </Checkbox>
                        </Col>
                    </div>
                    <div className='form-group col-md-2' style={ (self.state.marketplace) ? { display: '' } : { display: 'none' }}>
                        <label>Fee %</label>
                            <Form.Field name='moip.fee' placeholder='0' className='form-control'/>
                        <Form.Message htmlFor={'moip.fee'}/>
                    </div>
                </div>
                {contentPlatform}
                &nbsp;
                <div className='pull-right'>
                    <Form.Button type='submit' className='btn btn-primary' disabled={ self.state.loading }>Save</Form.Button>
                    &nbsp;
                    <button className="btn btn-danger" type="button" onClick={ self.goBack.bind(self) } disabled={ self.state.loading }>Cancel</button>
                </div>
            </Form>
        )

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1 className="page-header">Edit App</h1>
                    </div>
                </div>
                <div className="row col-md-12">
                    <div>
                        { content }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(AppEdit)



// WEBPACK FOOTER //
// ./components/AppEdit/index.js